const ralphaStart = /^[a-z]/;
const rautoPx = /^(?:Border(?:Top|Right|Bottom|Left)?(?:Width|)|(?:Margin|Padding)?(?:Top|Right|Bottom|Left)?|(?:Min|Max)?(?:Width|Height))$/;

export const isAutoPx = (prop: string) => {

  // The first test is used to ensure that:
  // 1. The prop starts with a lowercase letter (as we uppercase it for the second regex).
  // 2. The prop is not empty.
  return ralphaStart.test(prop) &&
    rautoPx.test(prop[0].toUpperCase() + prop.slice(1));
}